import clsx from 'clsx';
import { ComponentPropsWithoutRef, FC } from 'react';
import { AvatarHolder, chooseProfileColor, imageOrInitials } from '@elements-financial/elements';
import { Icon } from '../Icon';
import { chooseColorFromStringLength } from '../../../Scorecard';

export interface PersonAvatarProps extends Pick<ComponentPropsWithoutRef<'div'>, 'className'> {
  person?: AvatarHolder;
  onClick?: () => void;
}

export const PersonAvatar: FC<PersonAvatarProps> = ({ person, className, onClick = () => {} }) => {
  return (
    <>
      {person ? (
        imageOrInitials(person, (hasImage, value) => (
          <div
            className={clsx(className, 'relative grid h-10 w-10 place-content-center rounded-full overflow-clip')}
            style={{
              backgroundColor: chooseProfileColor(person),
            }}
            onClick={() => onClick()}
          >
            {hasImage ? (
              <img src={value} alt={'profile picture'} className="min-h-10 min-w-10 object-cover" />
            ) : (
              <span className="person-avatar-initials text-[17.5px] font-extrabold leading-[initial] tracking-[-0.01em] text-darkMode-gray-dark">
                {value}
              </span>
            )}
          </div>
        ))
      ) : (
        <div
          style={{
            backgroundColor: chooseColorFromStringLength(2),
            letterSpacing: '-0.31px',
            fontSize: '1.75rem',
          }}
          className={clsx(
            'text grid h-16 w-16 place-items-center rounded-full text-base font-extrabold leading-[2.1] text-darkMode-gray-dark',
            className
          )}
        >
          <Icon icon="person" className="h-6 w-6" />
        </div>
      )}
    </>
  );
};
